"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/spin/style/css");

var _spin = _interopRequireDefault(require("antd/es/spin"));

require("antd/es/input-number/style/css");

var _inputNumber = _interopRequireDefault(require("antd/es/input-number"));

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/space/style/css");

var _space = _interopRequireDefault(require("antd/es/space"));

require("antd/es/date-picker/style/css");

var _datePicker = _interopRequireDefault(require("antd/es/date-picker"));

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/select/style/css");

var _select = _interopRequireDefault(require("antd/es/select"));

require("antd/es/modal/style/css");

var _modal = _interopRequireDefault(require("antd/es/modal"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _ = _interopRequireWildcard(require("lodash"));

var _moment = _interopRequireDefault(require("moment"));

var _icons = require("@ant-design/icons");

var _form = _interopRequireDefault(require("antd/lib/form"));

var _reactDraggable = _interopRequireDefault(require("react-draggable"));

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

var _AppointmentModalHeader = require("../appointment/AppointmentModalHeader");

var _goals = require("../../redux/goals/goals.types");

var _HMPTextArea = _interopRequireDefault(require("../textarea/HMPTextArea"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  confirm
} = _modal.default;
const {
  Item,
  List
} = _form.default;
const {
  Option
} = _select.default;
var DeletedItemType;

(function (DeletedItemType) {
  DeletedItemType["connection"] = "connections";
  DeletedItemType["milestone"] = "milestones";
  DeletedItemType["task"] = "tasks";
  DeletedItemType["tip"] = "tips";
})(DeletedItemType || (DeletedItemType = {}));

const itemStyle = {
  marginBottom: '10px',
  marginTop: '10px'
};

class GoalForm extends _react.Component {
  constructor(props) {
    super(props);
    this.form = /*#__PURE__*/(0, _react.createRef)();

    this.handleSave = e => {
      const {
        createGoal,
        updateGoal,
        requestedGoalId
      } = this.props;
      const {
        isUnsaved
      } = this.state;

      if (this.form.current && isUnsaved) {
        this.form.current.validateFields().then(() => {
          confirm({
            title: 'Are you sure you want to save this goal?',
            content: '',
            okText: 'Confirm',
            onOk: () => {
              const {
                title,
                participantId,
                description,
                topicId,
                connections,
                milestones,
                tasks,
                tips,
                deleteDate,
                publishDate
              } = this.form.current.getFieldsValue();
              const {
                deletedItemsMap
              } = this.state;
              const deletedConnections = deletedItemsMap.get(DeletedItemType.connection);
              const deletedMilestones = deletedItemsMap.get(DeletedItemType.milestone);
              const deletedTasks = deletedItemsMap.get(DeletedItemType.task);
              const deletedTips = deletedItemsMap.get(DeletedItemType.tip);
              const itemDeleteDate = new Date();

              const mapDeleteDateToItem = item => ({ ...item,
                deleteDate: itemDeleteDate
              });

              const connectionsToSave = connections === null || connections === void 0 ? void 0 : connections.filter(c => c !== undefined);

              if (deletedConnections) {
                connectionsToSave === null || connectionsToSave === void 0 ? void 0 : connectionsToSave.push(...deletedConnections.map(mapDeleteDateToItem));
              }

              const milestonesToSave = milestones === null || milestones === void 0 ? void 0 : milestones.filter(m => m !== undefined);

              if (deletedMilestones) {
                milestonesToSave === null || milestonesToSave === void 0 ? void 0 : milestonesToSave.push(...deletedMilestones.map(mapDeleteDateToItem));
              }

              const tasksToSave = tasks === null || tasks === void 0 ? void 0 : tasks.filter(t => t !== undefined);

              if (deletedTasks) {
                tasksToSave === null || tasksToSave === void 0 ? void 0 : tasksToSave.push(...deletedTasks.map(mapDeleteDateToItem));
              }

              const tipsToSave = tips === null || tips === void 0 ? void 0 : tips.filter(t => t !== undefined);

              if (deletedTips) {
                tipsToSave === null || tipsToSave === void 0 ? void 0 : tipsToSave.push(...deletedTips.map(mapDeleteDateToItem));
              }

              const goalToSave = {
                title,
                participantId,
                description,
                topicId,
                connections: connectionsToSave,
                milestones: milestonesToSave,
                tasks: tasksToSave,
                tips: tipsToSave,
                deleteDate: deleteDate ? (0, _moment.default)(deleteDate).toISOString() : undefined,
                publishDate: publishDate ? (0, _moment.default)(publishDate).toISOString() : undefined
              };

              if (requestedGoalId && requestedGoalId.length > 0 && requestedGoalId !== 'new') {
                updateGoal({ ...goalToSave,
                  id: requestedGoalId
                });
                this.props.onUnsavedChange(false);
                this.setState({
                  isUnsaved: false
                });
              } else {
                createGoal(goalToSave);
                this.handleClose();
              }
            },

            onCancel() {}

          });
        });
      }
    };

    this.handleClose = () => {
      this.props.onUnsavedChange(false);
      this.setState({
        isUnsaved: false
      }); // TODO: find better solution than setTimeout

      setTimeout(() => this.props.closeHandler(), 1);
    };

    this.handleCancel = e => {
      this.props.closeHandler();
    };

    this.resetState = () => {
      var _a;

      this.setState({
        isUnsaved: false
      });
      this.props.onUnsavedChange(false);
      (_a = this.form.current) === null || _a === void 0 ? void 0 : _a.resetFields();
    };

    this.onChange = () => {
      this.setState({
        isUnsaved: true
      });
      this.props.onUnsavedChange(true);
    };

    this.onMouseOverHeader = () => {
      if (this.state.disableDrag) {
        this.setState({
          disableDrag: false
        });
      }
    };

    this.onMouseOutHeader = () => {
      if (!this.state.disableDrag) {
        this.setState({
          disableDrag: true
        });
      }
    };

    this.handleRemove = () => {
      const {
        requestedGoalId,
        deleteGoal,
        closeHandler
      } = this.props;

      if (requestedGoalId && requestedGoalId.length > 0) {
        deleteGoal(requestedGoalId);
        closeHandler();
      } else {
        closeHandler();
      }
    };

    this.handleItemRemove = (remove, name, type) => {
      var _a;

      const {
        requestedGoalId
      } = this.props;

      if (requestedGoalId && requestedGoalId.length > 0 && requestedGoalId !== 'new') {
        const deletedItemsMap = new Map(this.state.deletedItemsMap.entries());
        const existingItems = deletedItemsMap.get(type);
        const item = (_a = this.form.current) === null || _a === void 0 ? void 0 : _a.getFieldValue([type, name]);

        if (item) {
          if (existingItems) {
            deletedItemsMap.set(type, [...existingItems, item]);
          } else {
            deletedItemsMap.set(type, [item]);
          }

          this.setState({
            deletedItemsMap
          });
        }
      }

      remove(name);
    };

    this.state = {
      isUnsaved: false,
      disableDrag: true,
      loading: true,
      deletedItemsMap: new Map()
    };
    const {
      loadGoals,
      goalUIState
    } = this.props;
    loadGoals(goalUIState);
  }

  async componentDidMount() {
    const {
      requestedGoalId,
      getGoal
    } = this.props;

    if (requestedGoalId.length > 0 && requestedGoalId !== 'new') {
      await getGoal(requestedGoalId);
    }

    this.setState({
      loading: false
    });
  }

  componentDidUpdate(prevProps) {
    const {
      requestedGoal,
      requestedGoalId,
      getGoalStatus
    } = this.props;

    if (!prevProps.getGoalStatus.isSuccess && getGoalStatus.isSuccess && requestedGoal && this.form.current && requestedGoalId !== 'new' && requestedGoalId.length > 0) {
      this.form.current.setFieldsValue({ ...requestedGoal,
        // Must convert dates to Moment objects before passing values
        // to FormInstance.
        deleteDate: requestedGoal.deleteDate ? (0, _moment.default)(requestedGoal.deleteDate) : undefined,
        publishDate: requestedGoal.publishDate ? (0, _moment.default)(requestedGoal.publishDate) : undefined
      });
      this.setState({
        loading: false
      });
    }
  }

  render() {
    const {
      visible,
      requestedGoal,
      topics
    } = this.props;
    const {
      disableDrag,
      isUnsaved,
      loading
    } = this.state;
    const id = (requestedGoal === null || requestedGoal === void 0 ? void 0 : requestedGoal.id) ? requestedGoal === null || requestedGoal === void 0 ? void 0 : requestedGoal.id : 'new';
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      key: `goal-form-modal-${id}`,
      title: /*#__PURE__*/_react.default.createElement(_AppointmentModalHeader.AppointmentModalHeader, {
        editing: true,
        editClick: () => {},
        showRemove: !(requestedGoal === null || requestedGoal === void 0 ? void 0 : requestedGoal.deleteDate),
        removeClick: this.handleRemove,
        closeClick: this.handleCancel,
        showSave: isUnsaved,
        saveClick: this.handleSave,
        onMouseOver: this.onMouseOverHeader,
        onMouseOut: this.onMouseOutHeader
      }),
      visible: visible,
      onCancel: this.handleCancel,
      footer: null,
      closable: false,
      destroyOnClose: true,
      width: "50%",
      style: {
        minWidth: '400px'
      },
      modalRender: modal => /*#__PURE__*/_react.default.createElement(_reactDraggable.default, {
        disabled: disableDrag
      }, modal)
    }, !loading ? /*#__PURE__*/_react.default.createElement(_form.default, {
      ref: this.form,
      name: "goal-form",
      key: `goal-form-${id}`,
      layout: "vertical",
      colon: false,
      scrollToFirstError: true,
      onValuesChange: this.onChange,
      initialValues: {
        title: '',
        description: '',
        topicId: undefined,
        connections: [],
        milestones: [],
        tasks: [],
        tips: [],
        deleteDate: undefined,
        publishDate: undefined
      }
    }, /*#__PURE__*/_react.default.createElement(Item, {
      key: `title-${id}`,
      name: "title",
      label: "Title:",
      style: itemStyle,
      rules: [{
        required: true,
        message: 'Title is required.'
      }, {
        max: 255
      }]
    }, /*#__PURE__*/_react.default.createElement(_input.default, null)), /*#__PURE__*/_react.default.createElement(Item, {
      key: `description-${id}`,
      name: "description",
      label: "Description:",
      style: itemStyle,
      rules: [{
        required: true,
        max: 5000
      }]
    }, /*#__PURE__*/_react.default.createElement(_HMPTextArea.default, null)), /*#__PURE__*/_react.default.createElement(Item, {
      key: `topicId-${id}`,
      name: "topicId",
      label: "Topic:",
      style: itemStyle,
      rules: [{
        required: true,
        message: 'Type is required.'
      }]
    }, /*#__PURE__*/_react.default.createElement(_select.default, {
      showSearch: true,
      style: {
        width: 'auto',
        minWidth: 200
      },
      placeholder: "Choose a topic",
      optionFilterProp: "option",
      filterOption: (input, option) => {
        var _a;

        return ((_a = option === null || option === void 0 ? void 0 : option.title) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(input.toLowerCase())) >= 0;
      }
    }, topics && _.map(_.sortBy(topics, 'title'), topic => /*#__PURE__*/_react.default.createElement(Option, {
      key: `option-${topic.id}`,
      value: topic.id,
      title: topic.title
    }, topic.title)))), /*#__PURE__*/_react.default.createElement(Item, {
      key: `deleteDate-${id}`,
      name: "deleteDate",
      label: "Delete Date:",
      style: itemStyle
    }, /*#__PURE__*/_react.default.createElement(_datePicker.default, null)), /*#__PURE__*/_react.default.createElement(Item, {
      key: `publishDate-${id}`,
      name: "publishDate",
      label: "Publish Date:",
      style: itemStyle
    }, /*#__PURE__*/_react.default.createElement(_datePicker.default, {
      showTime: true
    })), /*#__PURE__*/_react.default.createElement(Item, {
      label: "Connections",
      style: itemStyle
    }, /*#__PURE__*/_react.default.createElement(List, {
      name: "connections"
    }, (fields, {
      add,
      remove
    }) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, fields.map(({
      key,
      name,
      fieldKey,
      ...restField
    }) => /*#__PURE__*/_react.default.createElement(_space.default, {
      key: key,
      style: {
        display: 'flex',
        marginBottom: 8,
        flexWrap: 'wrap'
      },
      align: "baseline"
    }, /*#__PURE__*/_react.default.createElement(_form.default.Item, Object.assign({}, restField, {
      name: [name, 'title'],
      fieldKey: [fieldKey, 'title'],
      rules: [{
        required: true,
        message: 'Title required'
      }, {
        max: 255
      }]
    }), /*#__PURE__*/_react.default.createElement(_input.default, {
      style: {
        minWidth: 200
      },
      placeholder: "Connection Title"
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, Object.assign({}, restField, {
      name: [name, 'uri'],
      fieldKey: [fieldKey, 'uri'],
      rules: [{
        max: 2048
      }]
    }), /*#__PURE__*/_react.default.createElement(_input.default, {
      style: {
        minWidth: 200
      },
      placeholder: "Connection Link"
    })), /*#__PURE__*/_react.default.createElement(_icons.MinusCircleOutlined, {
      onClick: () => this.handleItemRemove(remove, name, DeletedItemType.connection)
    }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, null, /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "dashed",
      onClick: () => add(),
      block: true,
      icon: /*#__PURE__*/_react.default.createElement(_icons.PlusOutlined, null)
    }, "Add connection"))))), /*#__PURE__*/_react.default.createElement(Item, {
      label: "Milestones",
      style: itemStyle
    }, /*#__PURE__*/_react.default.createElement(List, {
      name: "milestones"
    }, (fields, {
      add,
      remove
    }) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, fields.map(({
      key,
      name,
      fieldKey,
      ...restField
    }) => /*#__PURE__*/_react.default.createElement(_space.default, {
      key: key,
      style: {
        display: 'flex',
        marginBottom: 8,
        flexWrap: 'wrap'
      },
      align: "baseline",
      direction: "vertical"
    }, /*#__PURE__*/_react.default.createElement(_space.default, {
      key: `child-space-${key}`,
      style: {
        display: 'flex'
      },
      align: "baseline"
    }, /*#__PURE__*/_react.default.createElement(Item, Object.assign({}, restField, {
      name: [name, 'title'],
      fieldKey: [fieldKey, 'title'],
      rules: [{
        required: true,
        message: 'Title required'
      }, {
        max: 255
      }]
    }), /*#__PURE__*/_react.default.createElement(_input.default, {
      style: {
        minWidth: 200
      },
      placeholder: "Milestone Title"
    })), /*#__PURE__*/_react.default.createElement(Item, Object.assign({}, restField, {
      name: [name, 'sequence'],
      fieldKey: [fieldKey, 'sequence'],
      rules: [{
        required: true,
        message: 'Sequence required'
      }],
      initialValue: 0
    }), /*#__PURE__*/_react.default.createElement(_inputNumber.default, {
      min: 0
    })), /*#__PURE__*/_react.default.createElement(_icons.MinusCircleOutlined, {
      onClick: () => this.handleItemRemove(remove, name, DeletedItemType.milestone)
    })), /*#__PURE__*/_react.default.createElement(Item, Object.assign({}, restField, {
      name: [name, 'description'],
      fieldKey: [fieldKey, 'description'],
      rules: [{
        max: 5000
      }]
    }), /*#__PURE__*/_react.default.createElement(_HMPTextArea.default, {
      style: {
        minWidth: 400
      },
      placeholder: "Description"
    })))), /*#__PURE__*/_react.default.createElement(Item, null, /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "dashed",
      onClick: () => add(),
      block: true,
      icon: /*#__PURE__*/_react.default.createElement(_icons.PlusOutlined, null)
    }, "Add milestone"))))), /*#__PURE__*/_react.default.createElement(Item, {
      label: "Tasks",
      style: itemStyle
    }, /*#__PURE__*/_react.default.createElement(List, {
      name: "tasks"
    }, (fields, {
      add,
      remove
    }) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, fields.map(({
      key,
      name,
      fieldKey,
      ...restField
    }) => /*#__PURE__*/_react.default.createElement(_space.default, {
      key: key,
      style: {
        display: 'flex',
        marginBottom: 8,
        flexWrap: 'wrap'
      },
      align: "baseline"
    }, /*#__PURE__*/_react.default.createElement(_form.default.Item, Object.assign({}, restField, {
      name: [name, 'title'],
      fieldKey: [fieldKey, 'title'],
      rules: [{
        required: true,
        message: 'Title required'
      }, {
        max: 255
      }]
    }), /*#__PURE__*/_react.default.createElement(_input.default, {
      style: {
        minWidth: 200
      },
      placeholder: "Task Title"
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, Object.assign({}, restField, {
      name: [name, 'uri'],
      fieldKey: [fieldKey, 'uri'],
      rules: [{
        max: 2048
      }]
    }), /*#__PURE__*/_react.default.createElement(_input.default, {
      style: {
        minWidth: 200
      },
      placeholder: "Task Link"
    })), /*#__PURE__*/_react.default.createElement(_icons.MinusCircleOutlined, {
      onClick: () => this.handleItemRemove(remove, name, DeletedItemType.task)
    }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, null, /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "dashed",
      onClick: () => add(),
      block: true,
      icon: /*#__PURE__*/_react.default.createElement(_icons.PlusOutlined, null)
    }, "Add task"))))), /*#__PURE__*/_react.default.createElement(Item, {
      label: "Tips",
      style: itemStyle
    }, /*#__PURE__*/_react.default.createElement(List, {
      name: "tips"
    }, (fields, {
      add,
      remove
    }) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, fields.map(({
      key,
      name,
      fieldKey,
      ...restField
    }) => /*#__PURE__*/_react.default.createElement(_space.default, {
      key: key,
      style: {
        display: 'flex',
        marginBottom: 8,
        flexWrap: 'wrap'
      },
      align: "baseline"
    }, /*#__PURE__*/_react.default.createElement(_form.default.Item, Object.assign({}, restField, {
      name: [name, 'tip'],
      fieldKey: [fieldKey, 'tip'],
      rules: [{
        required: true,
        message: 'Tip required'
      }, {
        max: 255
      }]
    }), /*#__PURE__*/_react.default.createElement(_HMPTextArea.default, {
      style: {
        minWidth: 400
      },
      placeholder: "Tip"
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, Object.assign({}, restField, {
      name: [name, 'uri'],
      fieldKey: [fieldKey, 'uri'],
      rules: [{
        max: 2048
      }]
    }), /*#__PURE__*/_react.default.createElement(_input.default, {
      style: {
        minWidth: 200
      },
      placeholder: "Tip Link"
    })), /*#__PURE__*/_react.default.createElement(_icons.MinusCircleOutlined, {
      onClick: () => this.handleItemRemove(remove, name, DeletedItemType.tip)
    }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, null, /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "dashed",
      onClick: () => add(),
      block: true,
      icon: /*#__PURE__*/_react.default.createElement(_icons.PlusOutlined, null)
    }, "Add tip")))))) : /*#__PURE__*/_react.default.createElement(_spin.default, null));
  }

}

const mapStateToProps = state => {
  return {
    requestedGoal: selectors.getRequestedGoal(state),
    requestedGoalId: selectors.getRequestedEditGoalId(state),
    topics: selectors.getGoalTopics(state),
    goalUIState: selectors.selectGoalUIState(state),
    getGoalStatus: selectors.getGoalStatus(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getGoal: id => dispatch(_goals.getGoalAsync.request(id)),
    loadGoals: () => dispatch(_goals.getGoalsAsync.request({})),
    createGoal: goal => dispatch(_goals.createGoalAsync.request(goal)),
    updateGoal: goal => dispatch(_goals.updateGoalAsync.request(goal)),
    deleteGoal: id => dispatch(_goals.deleteGoalAsync.request(id))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GoalForm);

exports.default = _default;